/* eslint-disable jsx-a11y/anchor-is-valid */
"use client";
import React, { useState, useEffect, useCallback } from "react";
import ProfileImage from "../../public/profile-image.svg";
import { FaCaretDown } from "react-icons/fa";
import { BiMenu } from "react-icons/bi";
import { IoMdNotifications } from "react-icons/io";
// import Sidebar from "../../components/sidebar";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../utils/redux/hooks";
import { RootState } from "../../utils/redux/store";
import { adminLogout, getUser } from "../../utils/apis/func";
import {
  adddashboardActive,
  adduserData,
  logout,
} from "../../utils/redux/mainSlice";
import SidebarComp from "../components/sidebar2";
import ColorModeToggle from "../../components/ColorModeToggle";

import { Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerCloseButton, DrawerBody } from "@chakra-ui/react";
import AdminNavigation from "../../components/AdminNavigation";

const NewIndex = () => {
  const [profileModal, setProfileModal] = useState(false);
  const [profileRef, setprofileRef] = useState<null | any>(null);

  useEffect(() => {
    setprofileRef(document.getElementById("profile-container"));
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (profileRef && !profileRef.contains(event.target)) {
        setProfileModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileRef]);
  //
  let navigate = useNavigate();

  const toggleProfileModal = () => {
    setProfileModal(!profileModal);
  };

  const [profile, setProfile] = useState(false);

  const toggleProfile = () => {
    setProfile(!profile);
    setProfileModal(false);
    navigate("/profilePage");
    dispatch(adddashboardActive("profilePage"));
  };

  const dispatch = useAppDispatch();
  const userData: any = useAppSelector(
    (store: RootState) => store.user.userData
  );
  const authenticated = useAppSelector((store: RootState) => Boolean(store.user.isLoggedIn?.authenticated));

  const fetchData = useCallback(async () => {
    // console.log('started', d);
    const res: any = await getUser("");

    if (res?.status === 200 || res?.status === 201) {
      dispatch(adduserData(res?.data?.user));
    }
  }, [dispatch]);
  useEffect(() => { if (authenticated || localStorage.getItem("pw_admin_session") === "1") void fetchData(); }, [fetchData, authenticated]);

  // const { isOpen, onOpen, onClose } = useDisclosure();
  // const menuRef = useRef();

  const [open, setOpen] = React.useState(false);
  const openDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  const isLoggedIn = useAppSelector((store: RootState) => store.user.isLoggedIn);
  // The header + sidebar used to be hidden by string-matching the URL for
  // "login", so every OTHER signed-out route showed the full dashboard chrome:
  // on the bare domain the split yields "" for the first segment, so a visitor
  // with no session saw the sidebar and an admin name above a login box.
  // Whether to show the chrome is a question about the SESSION, not the URL.
  const signedIn =
    Boolean(isLoggedIn?.authenticated) ||
    (typeof window !== "undefined" &&
      window.localStorage.getItem("pw_admin_session") === "1");
  return (
    <main className="w-full min-h-screen bg-[#F7F7F7] pb-8">
      {signedIn && <a className="admin-skip-link" href="#admin-content">Skip to content</a>}
      <div className={`pb-4 ${signedIn ? "" : "hidden"}`}>
        <header className="admin-header flex items-center w-full bg-white py-3 lg:py-1 px-4 border border-[#fff] rounded-b-2xl shadow-sm ">
          <div className="flex min-w-0 flex-1 xl:flex-none xl:w-1/5 items-center justify-between gap-2 px-2">
            <React.Fragment>
              <button type="button" className="admin-menu-toggle" onClick={openDrawer} aria-label="Open navigation" aria-expanded={open}>
                <BiMenu size={26} />
              </button>
              <Drawer isOpen={open} onClose={closeDrawer} placement="left" size="xs">
                <DrawerOverlay />
                <DrawerContent maxW="min(320px, 90vw)" bg="admin.surface">
                  <DrawerCloseButton minW="44px" minH="44px" />
                  <DrawerHeader>Pureworker</DrawerHeader>
                  <DrawerBody p={3}><AdminNavigation onNavigate={closeDrawer} /></DrawerBody>
                </DrawerContent>
              </Drawer>
            </React.Fragment>

            <div className="flex min-w-0 gap-2 items-center">
              <div className="w-full ml-4 h-14 hidden lg:block rounded-full overflow-hidden">
                <img src={ProfileImage} alt="" className="w-full h-full " />
              </div>
              <p className="truncate text-sm font-semibold font-Roboto">
                {userData
                  ? `${userData.firstName} ${
                      userData.lastName ? userData.lastName.charAt(0) + "." : ""
                    }`
                  : "Loading..."}
              </p>
            </div>

            <div className="flex">
              <div
                className="flex items-center mt-1 sm:ml-0 cursor-pointer"
                onClick={toggleProfileModal}
              >
                <FaCaretDown size={20} className="text-[#8E8E93]" />
              </div>
            </div>
          </div>
          <div className="flex ml-auto pl-3 gap-3 items-center">
            <ColorModeToggle />
            {/* <div className="ml-10 flex items-center sm:hidden xl:flex">
              <FaSearch className="text-[#88087B]" />
              <input
                type="text"
                className=" rounded-full px-4 py-2 w-48 font-roboto text-sm font-normal leading-5 tracking-tighter text-[#8E8E93] focus:outline-none"
                placeholder="Quick search"
              />
            </div> */}
            <button type="button" aria-label="Notifications" className="relative min-h-[44px] min-w-[44px]" onClick={() => navigate("/notification")}>
              <IoMdNotifications
                size={30}
                className="text-[#88087B] cursor-pointer"
              />
              </button>
            {/* {notificationModal && (
              <>
                {" "}
                <NotificationModal />
              </>
            )} */}
          </div>
        </header>
      </div>
      {profileModal && (
        <div
          id="profile-container"
          className="fixed left-7 top-16  profile-modal-width bg-[#D9D9D9] z-50 rounded-md border border-[#88087B]"
        >
          <div className="flex flex-col">
            <p className="py-1 px-4 cursor-pointer" onClick={toggleProfile}>
              Profile
            </p>
            <span className="border-thin"></span>
            <p
              onClick={async () => {
                // Clearing local state is no longer enough to log out: the
                // session lives in an httpOnly cookie that only the server can
                // remove. Without this call the browser would keep sending a
                // valid session after the panel had "logged out" — the worst
                // kind of logout, because it looks like it worked.
                try {
                  await adminLogout();
                } catch {
                  /* clear the client side regardless; a stale cookie expires */
                }
                dispatch(logout());
                localStorage.removeItem("AuthToken");
                localStorage.removeItem("Role");
                localStorage.removeItem("pw_admin_session");
                setProfile(false);
                setProfileModal(false);
              }}
              className="py-1 px-4 cursor-pointer"
            >
              Logout
            </p>
          </div>
        </div>
      )}
      <SidebarComp profile={profile} setProfile={setProfile} />
    </main>
  );
};

export default NewIndex;
